module.exports = __webpack_public_path__ + "static/media/MuestraGratuita.01fac34d.pdf";